import { render, staticRenderFns } from "./TabDistribuicao.vue?vue&type=template&id=1cb7e75a&"
import script from "./TabDistribuicao.vue?vue&type=script&lang=js&"
export * from "./TabDistribuicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports